import {UscType} from './../../../models/profile/uscType';
import {GetHolderProfileCabinetResponsePayload} from '../../../models/api';
import {startDigitsSO} from '../../../constants';

export default {
  firstName: 'Максим',
  lastName: 'Кайгородцев',
  middleName: 'Игоревич',
  birthDate: '1984-10-02',
  sex: 0,
  passport: {
    num: '7505114106',
    date: '2010-03-01',
    codeOrg: '742025',
    org: 'УВД Г. МИАССА ЧЕЛЯБИНСКОЙ ОБЛ.',
    addressReg: '456316, Челябинская обл, г Миасс, ул Победы, д 29, кв 30',
  },
  snils: '48750603815',
  usc: `${startDigitsSO}112960209587`,
  dateIssue: '2020-03-01',
  oms: '4011989072892337',
  mobilePhone: '9061478529',
  email: '',
  address: '620137, Свердловская обл, г Екатеринбург, Кировский р-н, ул Советская, д 62, кв 66',
  uscType: UscType.Financial,
  uscIsBlocked: false,
} as GetHolderProfileCabinetResponsePayload;
